import { jsx as r } from "react/jsx-runtime";
import "react";
import "@mui/material/styles";
import "@mui/material/CssBaseline";
import { I as i } from "./Slider-vVmtecg6.js";
import { Box as m, Stack as p } from "@mui/material";
import "@mui/material/useAutocomplete";
import { faCheck as e } from "@fortawesome/pro-regular-svg-icons";
import "@emotion/cache";
import "@emotion/react";
import "@mui/material/Box";
import { T as s } from "./Typography-HkIo7ajX.js";
import "@fortawesome/fontawesome-svg-core";
import "@mui/material/Checkbox";
import "@fortawesome/pro-solid-svg-icons";
import "@fortawesome/pro-light-svg-icons";
import "@mui/material/Stack";
import "@mui/material/Link";
import "@mui/material/Tooltip";
import "@mui/material/Fade";
import "@mui/material/Button";
import "@fortawesome/pro-regular-svg-icons/faXmark";
import "@fortawesome/pro-solid-svg-icons/faCircle";
import "@mui/material/Chip";
import "@mui/material/Avatar";
import "@fortawesome/pro-light-svg-icons/faUser";
import "@mui/material/AvatarGroup";
import "@fortawesome/pro-regular-svg-icons/faPlus";
import "@mui/material/LinearProgress";
import "@mui/material/Tabs";
import "@mui/material/Tab";
import "./Tab-CO75KpXL.js";
import "@mui/material/ButtonGroup";
import "@mui/material/Switch";
import "@mui/material/Radio";
import "@mui/material/FormLabel";
import "@mui/material/Autocomplete";
import "@mui/material/FormHelperText";
import "@mui/material/FormControl";
import "@mui/material/OutlinedInput";
import "@mui/material/Input";
import "@mui/material/InputAdornment";
import "@fortawesome/pro-regular-svg-icons/faMagnifyingGlass";
import "@fortawesome/pro-solid-svg-icons/faCheck";
import "@fortawesome/pro-regular-svg-icons/faCircleQuestion";
import "@react-spring/web";
import "./ContentPanel-DRC79oum.js";
import "react-dropzone";
import "@vidstack/react";
import "@vidstack/react/player/layouts/default";
import "@vidstack/react/player/styles/default/theme.css";
import "@vidstack/react/player/styles/default/layouts/video.css";
import "@vidstack/react/icons";
import "@fortawesome/pro-light-svg-icons/faArrowUpRightFromSquare";
import "@fortawesome/pro-solid-svg-icons/faArrowRight";
import "@mui/material/Popper";
import "@fortawesome/pro-regular-svg-icons/faLinkSimple";
import "copy-text-to-clipboard";
import "@fortawesome/pro-solid-svg-icons/faExpandWide";
import "@fortawesome/pro-solid-svg-icons/faCompressWide";
import "@fortawesome/pro-solid-svg-icons/faUpRightAndDownLeftFromCenter";
import "@fortawesome/pro-solid-svg-icons/faDownLeftAndUpRightToCenter";
import "@fortawesome/pro-solid-svg-icons/faChevronsRight";
import "@fortawesome/pro-solid-svg-icons/faChevronsLeft";
import "@fortawesome/pro-solid-svg-icons/faToggleLargeOn";
import "@fortawesome/pro-solid-svg-icons/faToggleOff";
import "@fortawesome/pro-solid-svg-icons/faEye";
import "react-use";
import "color";
import "react-rnd";
import "react-hotkeys-hook";
import "./AutoScrollContainer-CzyjIY1o.js";
import "@tanstack/react-table";
import "@fortawesome/pro-regular-svg-icons/faArrowRight";
import "@fortawesome/pro-regular-svg-icons/faArrowLeft";
import "@fortawesome/pro-regular-svg-icons/faPenToSquare";
import "@fortawesome/pro-regular-svg-icons/faCircleXmark";
import "@fortawesome/pro-regular-svg-icons/faArrowDown";
import "@mui/material/Slider";
const a = "selected-icon", Ar = ({ option: t, isSelected: o }) => o && !t.hasCheckbox ? /* @__PURE__ */ r(
  m,
  {
    className: a,
    display: "flex",
    width: 20,
    alignItems: "center",
    children: /* @__PURE__ */ r(i, { icon: e })
  }
) : t.secondaryLabel ? /* @__PURE__ */ r(
  p,
  {
    sx: {
      "& p": {
        width: "auto",
        flexShrink: 0
      }
    },
    children: /* @__PURE__ */ r(
      s,
      {
        variant: "text",
        size: "sm",
        color: "grey.600",
        children: t.secondaryLabel
      }
    )
  }
) : null;
export {
  Ar as S,
  a as s
};
